import styled from 'styled-components'
import { drawStroke } from '../animate'

export const MapLineStyled = styled.svg`
  .stroke {
    stroke: ${props => props.theme};
  }
  .fill {
    fill: ${props => props.theme};
  }
  &.is-animated {
    &:hover {
      .draw-stroke-path {
        stroke-dasharray: 4;
        stroke-dashoffset: 12;
        animation: ${drawStroke} 1s linear forwards;
      }
    }
  }
`
